import React from "react";
import { Button, Modal } from "antd";
import { FaAngleLeft } from "react-icons/fa";
import moment from "moment/moment";

const OrderInfo = () => {
  const date = new Date();
  return (
    <>
      <div className="order_info_head_conta">
        <div className="or_in_hd_left">
          <div className="back_div">
            <span>
              <FaAngleLeft />
            </span>
            <h6>Back</h6>
          </div>
          <h3>Order Detail : #752</h3>
        </div>
        <div className="or_in_hd_right">
          <Button
            className="confirm_btn pading_class"
            //   onClick={showCnfModal}
          >
            Confirmed
          </Button>
        </div>
      </div>
      <div className="order_body_container">
        <div className="ord_left_body">
          <div className="user_info_box">
            <div className="order_info_container">
              <div className="order_info_box">
                <h6>Order date</h6>
                <p>{moment(date).format("DD MMM YYYY,h:mm A")}</p>
              </div>
              <div className="order_info_box">
                <h6>Order Expected</h6>
                <p>{moment(date).format("DD MMM YYYY,h:mm A")}</p>
              </div>
              <div className="order_info_box">
                <h6>Payment Mode</h6>
                <p>Online</p>
              </div>
              <div className="order_info_box">
                <h6>Restaurent Name</h6>
                <p>Pizza</p>
              </div>
              <div className="order_info_box_address ">
                <h6>Branch Address</h6>
                <p className="line_1_clamp">
                  Dexterous Technology, Flat No - 3, First Floor, Sharada
                  Complex, Plot No - 103,
                </p>
              </div>
            </div>
          </div>
          <div className="items_in_container">
            <span className="item_header">Food Items</span>
            <div className="item_show_cn">
              <div className="item_container_in">
                <div className="in_or_img">
                  <img src="/assets/logo/logo.jpg" alt="logo" />
                </div>
                <div className="or_in_detail">
                  <ul>
                    <li>Margorita x 5</li>
                    <li>₹7.79</li>
                    <li>Extra: Queso</li>
                    <li>Masa: Casabe</li>
                  </ul>
                </div>
              </div>
              <div className="item_container_in">
                <div className="in_or_img">
                  <img src="/assets/logo/logo.jpg" alt="logo" />
                </div>
                <div className="or_in_detail">
                  <ul>
                    <li>Margorita x 5</li>
                    <li>₹7.79</li>
                    <li>Extra: Queso</li>
                    <li>Masa: Casabe</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ord_right_body">
          <div className="user_info_box">
            <div className="user_data_box">
              <h6>USER NAME</h6>
              <p>Ajit</p>
              <h6>USER ADDRESS</h6>
              <p>
                Dexterous Technology, Flat No - 3, First Floor, Sharada Complex,
                Plot No - 103, Vengal Rao Nagar Rd, Kalyan Nagar Phase 1,
                Siddarth Nagar, Ameerpet, Hyderabad, Telangana 500038
              </p>
            </div>
          </div>
          <div className="user_info_box">
            <ul>
              <li>
                <span className="key_name">Order Price</span>
                <span className="value_name">₹155.85</span>
              </li>
              <li>
                <span className="key_name">Discount Amount</span>
                <span className="value_name">- ₹7.79</span>
              </li>
              <li>
                <span className="key_name">Delivery Charge</span>
                <span className="value_name">₹20.00</span>
              </li>
              <li>
                <span className="key_name">Task</span>
                <span className="value_name">₹24.94</span>
              </li>
              <li>
                <span className="key_name">Delivery Tip</span>
                <span className="value_name">₹155.85</span>
              </li>
              <li>
                <span className="key_name_total">Total Price</span>
                <span className="key_name_total">₹218.00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderInfo;
